import { Component, ViewChild, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { LocalDataSource } from 'ng2-smart-table';

//Interfaces
import { RetiradaBrinde, MovEstoque, Pessoa } from 'app/interfaces';

//Services
import { PessoasService } from 'app/services/pessoas';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'buscar-pessoa-modal',
  styleUrls: ['./buscar-pessoa-modal.component.scss'],
  templateUrl: './buscar-pessoa-modal.component.html'
})
export class BuscarPessoaModalComponent {
  @Output() atualizaBarcode = new EventEmitter();

  @ViewChild('inputNomeRazao') inputNomeRazao;

  public pessoas: Pessoa[] = undefined;
  public selecionada: Pessoa = undefined;
  public nome_razao: string = '';

  public tipos_funcionais = [];

  public settings = {
    hideSubHeader: true,
    selectMode: 'single',
    noDataMessage: "Sem dados para exibir...",
    pager: {
      perPage: 5
    },
    actions: null,
    add: null,
    edit: null,
    delete: null,
    columns: {
      id: {
        title: 'ID',
        filter: false,
      },
      cd_virtage: {
        title: 'Virtual Age',
        type: 'string',
        filter: false,
      },
      nome_razao: {
        title: 'Nome',
        type: 'string',
        filter: false,
        class: 'colunaNome',
        valuePrepareFunction: (cell, row) => {
          return !!row.pessoa ? row.pessoa.nome_razao + ' - ' + row.pessoa.fantasia : cell;
        }
      },
      cpf_cnpj: {
        title: 'CNPJ / CPF',
        type: 'string',
        filter: false
      },
    }
  };

  public source: LocalDataSource = new LocalDataSource([]);

  constructor(
    private activeModal: NgbActiveModal,
    private pessoaData: PessoasService,
    private toastr: ToastrService
  ) {

  }

  ngOnInit() { }

  ngAfterViewInit() {
    this.focaBusca();
  }

  focaBusca() {
    this.inputNomeRazao.nativeElement.focus();
  }

  buscaPessoa(dados) {
    this.pessoaData.getLista({ nome_razao: dados, tipo_funcional: this.tipos_funcionais }).then((resposta) => {
      this.pessoas = resposta;
      this.source.load(this.pessoas);
    });
  }

  onSelect(selecao) {
    if (!selecao.isSelected) {
      this.selecionada = undefined;
    } else {
      this.selecionada = selecao.data;
    }
  }

  selecionar() {
    this.atualizaBarcode.emit(this.selecionada.cpf_cnpj);
    this.activeModal.close();
  }

  closeModal() {
    this.activeModal.close();
  }
}



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/pages/modals/buscar-pessoa-modal/buscar-pessoa-modal.component.ts